import React from "react";
import PropTypes from "prop-types";

import Gate from "components/Gate";
import Overlay from "components/Overlay";

import "./Modal.css";

export default class Modal extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.node,
    fitScreen: PropTypes.bool
  }

  static defaultProps = {
    isOpen: true,
    fitScreen: false
  }

  render() {
    const classNames = ["modal"];

    if(!this.props.fitScreen){
      classNames.push("modal-frame");
    }

    return (
      <Gate isOpen={this.props.isOpen}>
        <Overlay>
          <div className="modal-wrapper">
            <div className={classNames.join(" ")}>
              { this.props.children }
            </div>
          </div>
        </Overlay>
      </Gate>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Modal.js